<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="身份：">
        <el-select v-model="query.CLevel" placeholder="请选择" clearable size="small">
          <el-option label="研修班" :value="6"></el-option>
          <el-option label="体验班" :value="7"></el-option>
          <el-option label="普通用户" :value="8"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值账户：">
        <el-select v-model="query.mainId" placeholder="请选择" clearable size="small">
          <el-option label="主账号" :value="0"></el-option>
          <el-option label="子账号" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入账账户：">
        <el-select v-model="query.accountType" placeholder="请选择" clearable size="small">
          <el-option label="主账户" :value="1"></el-option>
          <el-option label="子账户" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值方式：">
        <el-select v-model="query.dataSource" placeholder="请选择" clearable size="small">
          <el-option label="APP充值" :value="4"></el-option>
          <el-option label="线下充值" :value="5"></el-option>
          <el-option label="自己升级" :value="1"></el-option>
          <el-option label="老师升级" :value="2"></el-option>
          <el-option label="后台升级" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="付款时间：" v-if="query.dataSource === 5">
        <el-date-picker v-model="payDateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import { filterEmpty } from '@/utils'
export default {
  props: ['orderType'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {


      },
      payDateTime: []
    }
  },
  created() {
    this.query.orderType = this.orderType;
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.payStartTime = this.query.dataSource === 5 && this.payDateTime && this.payDateTime.length > 0 ? this.payDateTime[0] : undefined
      this.query.payEndTime = this.query.dataSource === 5 && this.payDateTime && this.payDateTime.length > 0 ? this.payDateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => rechargeRecordApi.tuitionListExport(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>